import React, { useState, useEffect, lazy, Suspense } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import BlogContentPage from "./pages/BlogContentPage.js";
import Blogs from "./pages/Blog.js";
import Footer from "./components/Footer.js";
import Popup from "./components/popup.js";
import HTMLSitemap from "./components/HTMLSitemap.js";
import { ThankYouMessage } from "./components/ThankYouMessage";
import { RightButtonPopup } from "./components/RightButtonPopup";
import { Helmet, HelmetProvider } from "react-helmet-async";

import ScrollToTop from "./pages/ScrollToTop.js";
import styles from "../src/Brandcut/styles/App.module.css";
import HeroSection from "../src/Brandcut/components/HeroSection.js";
import SectionTwo from "../src/Brandcut/components/SectionTwo.js";
import SectionThree from "../src/Brandcut/components/SectionThree.js";
import SectionFour from "../src/Brandcut/components/SectionFour.js";
import SectionFive from "../src/Brandcut/components/SectionFive.js";
import SectionSix from "../src/Brandcut/components/SectionSix.js";
import ContactSection from "../src/Brandcut/components/ContactSection.js";
import LeadForm from "../src/Brandcut/components/LeadForm.js";
import ThankYouPage from "../src/Brandcut/components/ThankYouSection.js";
import About from "./pages/About.js";
import Platform from "./pages/Platform.js";
import ThankYouPagehome from "./pages/Thankyoupage.js";
import Solutions from "./pages/Solution.js";
import Usecases from "./pages/usecases-new.js";
import Visualai from "./pages/visualai.js";
import Integration from "./pages/Integration.js";
import Home from "./pages/Home.js";
import Managed from "./pages/Managed.js";
import Workshop from "./pages/Workshop.js";
import Workshopduplicate from "./pages/workshopduplicate.js";
import Career from "./pages/Career.js";
import BlogContent from "./pages/BlogContent.js";
import Brochures from "./pages/Brochures.js";
import Contact from "./pages/Contact.js";
import Individualcourse from "./pages/Individualcourse.js";
import Corporatecourse from "./pages/Corporatecourse.js";
import CarrerChange from "./pages/CareerChange.js";
import Terms from "./pages/Terms.js";
import Privacy from "./pages/Privacy.js";
import BlogCategory from "./pages/BlogCategory.js";
import Fortunecookie from "./pages/Fortunecookie.js";
import Webinar from "./pages/Webinar.js";
import Podcast from "./pages/Podcast.js";
import Casestudy from "./pages/casestudy.js";
import Casestudycontent from "./pages/casestudycontent.js";
import AcademyContent from "./pages/AcademyContent.js";
import ShortContent from "./pages/ShortContent.js";
import CareerContent from "./pages/CareerContent.js";
import ProfessionalCourse from "./pages/ProfessionalCourse.js";
import ShortCourse from "./pages/ShortCourses.js";
import ProfessionalContent from "./pages/ProfessionalContent.js";
import WorkshopCourse  from "./pages/Worshopcourse.js";
import Events from "./pages/Events";
import Media from "./pages/Media.js";
import SuccessPage from "./pages/SuccessPage.js";
import CancelPage from "./pages/CancelPage.js";
import Success from "../src/Ai-read/src/pages/SuccessPage.js";
import Cancel from "../src/Ai-read/src/pages/CanceledPage.js";
import LiteracyPage from "./Ai-read/src/pages/LiteracyPage.js";
import Knudge from "../src/K-nudge/src/pages/nudge.js";
const Appjs = lazy(() => import("../src/Ai-read/src/pages/Homepage.js"));

export default function App() {
  const [showThankYou, setShowThankYou] = useState(false);
  const [isLeadFormVisible, setIsLeadFormVisible] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const location = useLocation();

  const [showRightButtonPopup, setShowRightButtonPopup] = useState(false);

  const handleRightButtonPopupClick = () => {
    setShowRightButtonPopup(true);
  };

  const handleCloseAllPopups = () => {
    setShowRightButtonPopup(false);
  };

  const openLeadForm = () => setIsLeadFormVisible(true);
  const helmetContext = {};
  const handleThankYouClick = () => {
    setShowThankYou(true);
  };
  const hideNavAndFooterRoutes = [
    "/visual-ai",
    "/visual-ai/",
    "/visual-ai/thankyou/",
    "/visual-ai/thankyou",
    "/workshop/",
    "/workshop",
  ];
  const shouldHideNavAndFooter = hideNavAndFooterRoutes.includes(
    location.pathname
  );

  return (
    <>
      <HelmetProvider context={helmetContext}>
        <Suspense fallback={<div></div>}>
          {!shouldHideNavAndFooter && <Navbar />}
          <ScrollToTop />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog/" element={<Blogs />} />
            <Route path="/academy/" element={<Individualcourse />} />
            <Route path="/academy/for-individuals/" element={<Individualcourse />} />
            <Route path="/academy/for-corporates/" element={<Corporatecourse />} />
            <Route path="/academy/career-advancement-courses/" element={<CarrerChange />} />
            <Route path="/academy/professional-growth-courses/" element={<ProfessionalCourse />} />
            <Route path="/academy/workshops" element={<WorkshopCourse />} />
            <Route path="/academy/bite-sized-courses/" element={<ShortCourse />} />
            <Route path="/academy/career-advancement-courses/:slug/" element={<AcademyContent />} />
            <Route path="/academy/for-individuals/:slug/" element={<CareerContent />} />
            <Route path="/academy/professional-growth-courses/:slug/" element={<ProfessionalContent />} />
            <Route path="/academy/bite-sized-courses/:slug/" element={<ShortContent />} />
            <Route path="/blog/:blogTitle/" element={<BlogContentPage />} />
            <Route path="/blogcontentpage/" element={<BlogContentPage />} />
            <Route path="/blogcontent/" element={<BlogContent />} />
            <Route path="/brochures/" element={<Brochures />} />
            <Route path="/ai-workshop-for-corporates/" element={<Workshop />} />
            <Route path="success" element={<SuccessPage />} />
            <Route path="/cancel" element={<CancelPage/>}/>
            <Route path="/workshop/" element={<Workshopduplicate />} />
            <Route path="/playlab/" element={<Events />} />
            <Route path="/media-futures/" element={<Media />} />
            <Route path="/ai-readiness-index/" element={<Appjs />} />
            <Route path="/ai-readiness-index/for-literacy" element={<LiteracyPage/>}/>
             <Route path="/solutions/" element={<Solutions />} />
            <Route path="/usecases/" element={<Usecases />} />
            <Route path="/successpage" element ={<Success/>} />
            <Route path="/canceledpage" element ={<Cancel/>} />
            <Route path="/webinars/" element={<Webinar />} />
            <Route path="/visual-ai/" element={<Visualai />} />
            <Route path="/visual-ai/thankyou/" element={<ThankYouPagehome />} />
            <Route path="/podcasts/" element={<Podcast />} />
            <Route path="/casestudy/" element={<Casestudy />} />
            <Route path="/casestudy/:title" element={<Casestudycontent />} />
            <Route path="/ai-integration/" element={<Integration />} />
            <Route path="/ai-managed-services/" element={<Managed />} />
            <Route path="/about-us/" element={<About />} />
             <Route path="/platform/" element={<Platform/>} />
            <Route path="/careers/" element={<Career />} />
            <Route path="/popup" element={<Popup />} />
            <Route path="/contact-us/" element={<Contact />} />
            <Route path="/terms-of-service/" element={<Terms />} />
            <Route path="/privacy-policy/" element={<Privacy />} />
            <Route path="/fortunecookie/" element={<Fortunecookie />} />
            <Route path="/knowledge-nudge/" element={<Knudge />} />
            <Route path="/sitemap.html" element={<HTMLSitemap />} />
            <Route path="/blog/category/:category" element={<BlogCategory />} />
            <Route
              path="/brandcut/"
              element={
                <div>
                  <div className={styles.section}>
                    <HeroSection onOpenLeadForm={openLeadForm} />
                  </div>
                  <SectionTwo onOpenLeadForm={openLeadForm} />
                  <div className={styles.section2}>
                    <SectionThree />
                  </div>
                  <SectionFour />
                  <SectionFive onOpenLeadForm={openLeadForm} />
                  <div className={styles.section3}>
                    <SectionSix />
                  </div>
                  <div className={styles.section4}>
                    <ContactSection
                      visible={isLeadFormVisible}
                      onClose={() => setIsLeadFormVisible(false)}
                      onSubmit={() => setIsSubmitted(true)}
                    />
                  </div>

                  <LeadForm
                    visible={isLeadFormVisible}
                    onClose={() => setIsLeadFormVisible(false)}
                    onSubmit={() => setIsSubmitted(true)}
                  />
                </div>
              }
            />
            <Route
              path="/thank-you"
              element={isSubmitted ? <ThankYouPage /> : <Navigate to="/" />}
            />
          </Routes>
          {!shouldHideNavAndFooter && <Footer />}
        </Suspense>
      </HelmetProvider>
    </>
  );
}
